<template>
    <v-app>

        <template v-if="!show_poll_deleted_layout">
            <transition name="fade">
                <v-parallax
                        v-show="!page_loading"
                        id="event_background"
                        height="100%"
                        jumbotron
                >
                    <v-content>
                        <v-container class="page" fluid fill-height>
                            <v-layout align-center justify-center>
                                <v-flex xs12 sm10 md8>
                                    <v-card class="mb-2">
                                        <v-img
                                                :src="getPollCover"
                                                gradient="to top, rgba(0,0,0,.8) 0, rgba(0,0,0,.6) 5%, rgba(0,0,0,0) 40%"                                    height="300px"
                                        >
                                            <v-layout
                                                    column
                                                    fill-height
                                            >
                                                <v-card-title class="justify-end">
                                                    <v-btn
                                                            v-if="currentLanguage === 'en'"
                                                            color="blue darken-2"
                                                            dark
                                                            small
                                                            class="text-capitalize lang-btn"
                                                            @click="changeLanguage('tc')"
                                                    >
                                                        中文
                                                    </v-btn>
                                                    <v-btn
                                                            v-else-if="currentLanguage === 'tc'"
                                                            color="blue darken-2"
                                                            dark
                                                            small
                                                            class="text-capitalize lang-btn"
                                                            @click="changeLanguage('en')"
                                                    >
                                                        En
                                                    </v-btn>
                                                    <v-spacer></v-spacer>
                                                </v-card-title>
                                                <v-spacer />
                                                <v-card-title class="white--text">
                                                    <div class="display-1 pl-2 pb-2">{{poll_data.title}}</div>
                                                </v-card-title>

                                                <div class="cover-copy-right-wp">{{$t('app.copy_right')}} {{$t('app.company_name')}}</div>
                                            </v-layout>
                                        </v-img>

                                        <v-card-text class="pa-0">
<!--                                            <v-alert-->
<!--                                                    :value="!poll_data.is_pollable"-->
<!--                                                    type="info"-->
<!--                                                    class="mt-0"-->
<!--                                            >-->
<!--                                                {{$t('event.poll.msg_poll_finish')}}-->
<!--                                            </v-alert>-->

<!--                                            <v-list class="pa-0">-->
<!--                                                <v-list-tile class="align-start fill-height">-->
<!--                                                    <v-list-tile-action>-->
<!--                                                        <v-icon color="indigo">event</v-icon>-->
<!--                                                    </v-list-tile-action>-->
<!--                                                    -->
<!--                                                </v-list-tile>-->
<!--                                            </v-list>-->
                                        </v-card-text>

                                        <v-card-text v-show="show_poll_form">
                                            <v-form method="post" :action="form.action" v-on:success="pollSuccess" ref="poll_form">

                                                <input type="hidden" name="poll_id" v-model="poll_data.encrypted_id">
                                                <input type="hidden" name="date_times" v-model="form.data.date_times">
                                                <input type="hidden" name="locations" v-model="form.data.locations">
                                                <input type="hidden" name="activities" v-model="form.data.activities">

                                                <v-alert
                                                        :value="form.errors.general !== ''"
                                                        type="error"
                                                >
                                                    {{form.errors.general}}
                                                </v-alert>

                                                <v-card class="elevation-0">
                                                    <v-card-text class="pa-2">
                                                        <div class="layout column">
                                                            <h1 class="flex my-4 primary--text">{{$t("event.poll.pre_event_poll")}}</h1>
                                                        </div>

                                                        <v-container grid-list-lg pa-0 ma-0>
                                                            <v-layout row wrap>
                                                                <v-flex xs4 sm2>
                                                                    <v-text-field
                                                                            type="tel"
                                                                            name="area_code"
                                                                            prefix="+"
                                                                            v-model="form.data.area_code"
                                                                            :error-messages="form.errors.area_code"
                                                                            :label="$t('contact.area_code')"
                                                                            mask="###"
                                                                    />
                                                                </v-flex>
                                                                <v-flex xs8 sm4>
                                                                    <v-text-field
                                                                            type="tel"
                                                                            append-icon="phone"
                                                                            name="contact_phone"
                                                                            v-model="form.data.contact_phone"
                                                                            :error-messages="form.errors.contact_phone"
                                                                            :label="$t('registration.contact_phone')"
                                                                            :mask="phoneMask"
                                                                            ref="contact_phone"
                                                                    />
                                                                </v-flex>
                                                                <v-flex xs12 sm6>
                                                                    <v-text-field
                                                                            append-icon="person"
                                                                            ref="full_name"
                                                                            name="full_name"
                                                                            v-model="form.data.full_name"
                                                                            :error-messages="form.errors.full_name"
                                                                            :label="$t('registration.your_name')"
                                                                    />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap v-show="poll_data.time_question.options.length">
                                                                <v-flex xs12>
                                                                    <h3>{{$t('event.poll.time_options')}} <template v-if="poll_data.time_question.is_multiple">({{$t('event.poll.allow_multiple')}})</template></h3>
                                                                    <div v-if="poll_data.time_question.is_multiple">
                                                                        <template v-for="time_item in poll_data.time_question.options">
                                                                            <v-checkbox
                                                                                    v-model="form.data.date_times"
                                                                                    class="mt-0 mb-3 poll-checkbox-item"
                                                                                    color="indigo"
                                                                                    :label="getTimeOptionText(time_item.value)"
                                                                                    :value="time_item.id"
                                                                                    hide-details
                                                                            />
                                                                        </template>
                                                                        <v-input ref="date_times" :error-messages="form.errors.date_times" />
                                                                    </div>
                                                                    <v-radio-group
                                                                            v-else
                                                                            v-model="form.data.date_times"
                                                                            ref="date_times"
                                                                            :error-messages="form.errors.date_times"
                                                                            row
                                                                    >
                                                                        <template v-for="(time_item) in poll_data.time_question.options">
                                                                            <v-radio class="mb-3" :label="getTimeOptionText(time_item.value)" :value="time_item.id" color="primary" />
                                                                        </template>
                                                                    </v-radio-group>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap v-show="poll_data.location_question.options.length">
                                                                <v-flex xs12>
                                                                    <h3>{{$t('event.poll.location_options')}} <template v-if="poll_data.location_question.is_multiple">({{$t('event.poll.allow_multiple')}})</template></h3>
                                                                    <div v-if="poll_data.location_question.is_multiple">
                                                                        <template v-for="location_item in poll_data.location_question.options">
                                                                            <v-checkbox
                                                                                    v-model="form.data.locations"
                                                                                    class="mt-0 mb-3 poll-checkbox-item"
                                                                                    color="indigo"
                                                                                    :label="location_item.value"
                                                                                    :value="location_item.id"
                                                                                    hide-details
                                                                            />
                                                                        </template>
                                                                        <v-input ref="locations" :error-messages="form.errors.locations" />
                                                                    </div>
                                                                    <v-radio-group
                                                                            v-else
                                                                            ref="locations"
                                                                            v-model="form.data.locations"
                                                                            :error-messages="form.errors.locations"
                                                                            row
                                                                    >
                                                                        <template v-for="location_item in poll_data.location_question.options">
                                                                            <v-radio class="mb-3" :label="location_item.value" :value="location_item.id" color="primary" />
                                                                        </template>
                                                                    </v-radio-group>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap v-show="poll_data.activity_question.options.length">
                                                                <v-flex xs12>
                                                                    <h3>{{$t('event.poll.activity_options')}} <template v-if="poll_data.activity_question.is_multiple">({{$t('event.poll.allow_multiple')}})</template></h3>
                                                                    <div v-if="poll_data.activity_question.is_multiple">
                                                                        <template v-for="activity_item in poll_data.activity_question.options">
                                                                            <v-checkbox
                                                                                    v-model="form.data.activities"
                                                                                    class="mt-0 mb-3 poll-checkbox-item"
                                                                                    color="indigo"
                                                                                    :label="activity_item.value"
                                                                                    :value="activity_item.id"
                                                                                    hide-details
                                                                            />
                                                                        </template>
                                                                        <v-input ref="activities" :error-messages="form.errors.activities" />
                                                                    </div>
                                                                    <v-radio-group
                                                                            v-else
                                                                            ref="activities"
                                                                            v-model="form.data.activities"
                                                                            :error-messages="form.errors.activities"
                                                                            row
                                                                    >
                                                                        <template v-for="activity_item in poll_data.activity_question.options">
                                                                            <v-radio class="mb-3" :label="activity_item.value" :value="activity_item.id" color="primary" />
                                                                        </template>
                                                                    </v-radio-group>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-btn
                                                                block
                                                                color="primary"
                                                                type="submit"
                                                                :loading="form.loading"
                                                        >{{$t('action.submit')}}</v-btn>
                                                    </v-card-actions>
                                                </v-card>

                                            </v-form>
                                        </v-card-text>

                                        <v-card-text v-show="show_poll_success_layout">
                                            <v-card class="elevation-0 text-xs-center">
                                                <v-card-text class="py-0 pt-2">
                                                    <v-icon size="64" color="green">fa-check</v-icon>
                                                </v-card-text>
                                                <v-card-text color="green" class="py-2">
                                                    <h3 class="notification-header green--text">{{$t('general.success')}}</h3>
                                                </v-card-text>
                                                <v-card-text>
                                                    {{$t('event.poll.msg_poll_success')}}
                                                </v-card-text>
                                                <v-card-text class="title">
                                                    {{$t('event.poll.poll_details')}}:
                                                </v-card-text>
                                                <v-card-text>
                                                    <table class="details-table">
                                                        <tbody>
                                                        <tr>
                                                            <th>{{$t('registration.your_name')}}:</th>
                                                            <td>{{form.data.full_name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>{{$t('registration.contact_phone')}}:</th>
                                                            <td>+{{form.data.area_code}}-{{form.data.contact_phone}}</td>
                                                        </tr>
                                                        <tr v-if="hasOptions(form.data.date_times)">
                                                            <th>{{$t('event.poll.time_options')}}:</th>
                                                            <td>{{getOptionTextByIds(form.data.date_times).join(', ')}}</td>
                                                        </tr>
                                                        <tr v-if="hasOptions(form.data.locations)">
                                                            <th>{{$t('event.poll.location_options')}}:</th>
                                                            <td>{{getOptionTextByIds(form.data.locations).join(', ')}}</td>
                                                        </tr>
                                                        <tr v-if="hasOptions(form.data.activities)">
                                                            <th>{{$t('event.poll.activity_options')}}:</th>
                                                            <td>{{getOptionTextByIds(form.data.activities).join(', ')}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </v-card-text>

                                                <v-card-text>
                                                    <v-btn
                                                            block
                                                            color="primary"
                                                            @click="refreshPage"
                                                    >{{$t('action.back')}}</v-btn>
                                                </v-card-text>

                                            </v-card>
                                        </v-card-text>

                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-content>
                </v-parallax>
            </transition>
            <transition name="fade">
                <v-layout full-height align-center justify-center>
                    <v-progress-circular
                            v-show="page_loading"
                            indeterminate
                            color="primary"
                    ></v-progress-circular>
                </v-layout>
            </transition>
        </template>
        <v-container v-else fluid fill-height>
            <v-layout align-center justify-center>
                <div class="text-xs-center">
                    <v-icon size="150">error</v-icon>
                    <h2 class="my-3 headline ">{{$t('event.msg_event_not_found')}}</h2>
                </div>
            </v-layout>
        </v-container>

        <app-footer />
    </v-app>
</template>

<script>
    import AppFooter from "~/components/AppFooter";
    import FormHandling from "~/utils/data/form-handling"
    import {UrlServices} from "~/utils/url-manager";
    import RequestHandler from "~/utils/request-handler";
    import Utils from "~/utils/index"

    export default {
        name: "Index",
        components: {
            AppFooter
        },
        data() {
            return {
                show_poll_form: false,
                show_poll_success_layout: false,
                show_poll_deleted_layout: false,
                page_loading: false,
                poll_option_text_list: {},
                poll_data: {
                    title: '--',
                    time_question: {
                        options: []
                    },
                    location_question: {
                        options: []
                    },
                    activity_question: {
                        options: []
                    }
                },
                form: {
                    form_handling_obj: null,
                    loading: false,
                    action: UrlServices.createUrl({name: 'api_public_poll_submit'}),
                    data: {
                        area_code: 852,
                        contact_phone: "",
                        full_name: "",
                        date_times: [],
                        locations: [],
                        activities: []
                    },
                    errors: {
                        general: "",
                        area_code: "",
                        contact_phone: "",
                        full_name: "",
                        date_times: "",
                        locations: "",
                        activities: "",
                    }
                },
                phoneMask: '#'.repeat(50),
            };
        },
        computed: {
            currentLanguage() {
                return this.$store.state.lang;
            },
            getPollCover() {
                return this.poll_data.cover_file ? this.poll_data.cover_file.absolute_url : '/images/background/poll_bg.jpg';
            },
        },
        methods: {
            pollSuccess() {
                this.show_poll_form = false;
                this.show_poll_success_layout = true;
            },
            getTimeOptionText(value) {
                return Utils.getPeriodText(value['start_time'], value['end_time']);
            },
            changeLanguage(language) {
                this.$store.dispatch('setLang', language).then(() => {
                    this.$router.replace({params: {'lang': language}, query: this.$route.query});
                });
            },
            getPollData() {
                let me = this;
                let poll_id = this.$route.query.pid;

                me.page_loading = true;
                if(poll_id){
                    RequestHandler.Get(UrlServices.createUrl({name: 'api_public_poll_get'}), {
                        poll_id: poll_id
                    }, {
                        'success': function (data) {
                            me.poll_data = data.poll_data;

                            let option_text_list = {};
                            _.each(me.poll_data['time_question']['options'], function(option) {
                                option_text_list[option.id] = me.getTimeOptionText(option.value);
                            });
                            _.each(me.poll_data['location_question']['options'], function(option) {
                                option_text_list[option.id] = option.value;
                            });
                            _.each(me.poll_data['activity_question']['options'], function(option) {
                                option_text_list[option.id] = option.value;
                            });

                            me.poll_option_text_list = option_text_list;

                            me.show_poll_form = true;
                            me.page_loading = false;
                        },
                        'error': function(data) {
                            if(data.error_type == 'poll_deleted'){
                                me.page_loading = false;
                                me.show_poll_deleted_layout = true;
                            } else {
                                me.$router.replace({name: 'error_404'});
                            }
                        }
                    });
                } else {
                    this.$router.replace({name: 'error_404'});
                }
            },
            hasOptions(value) {
                if(Array.isArray(value)){
                    return value.length;
                } else {
                    return !!value;
                }
            },
            getOptionTextByIds(ids) {
                if(!Array.isArray(ids)){
                    ids = [ids];
                }
                let me = this;
                let names = [];
                _.each(ids, function(option_id){
                    if(me.poll_option_text_list[option_id]){
                        names.push(me.poll_option_text_list[option_id]);
                    }
                });
                return names;
            },
            refreshPage() {
                window.location.reload();
            },
        },
        mounted() {
            let me = this;
            this.getPollData();
            this.form.form_handling_object = new FormHandling(this, "poll_form", this.form);
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>

<style>
    .full-height .v-list__tile {
        height: 100%;
    }

    #event_background.v-parallax {
        height: 100%;
    }

    #event_background.v-parallax .v-parallax__image-container img {
        -webkit-filter: blur(15px);
        -moz-filter: blur(15px);
        -o-filter: blur(15px);
        -ms-filter: blur(15px);
        filter: blur(15px);
    }

    .event-info-text img {
        max-width: 100%;
    }

    .cover-copy-right-wp {
        position: absolute;
        bottom: 5px;
        right: 5px;
        background-color: rgba(0,0,0,0.5);
        color: #FFF;
        padding: 0 5px;
        border-radius: 3px;
    }

    table.details-table {
        margin: 0 auto;
    }

    .details-table th{
        text-align: left;
        padding-right: 15px;
    }
    .details-table td{
        text-align: left;
    }

    .notification-header {
        font-size: 26px;
    }

    @media screen and (max-width: 900px) {
        #event_background .v-parallax__content {
            padding: 0;
        }

        #event_background .container {
            padding: 8px;
        }
    }
</style>